// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__20IqH","errorLogs":"styles_errorLogs__2Ig-j"};